import { styled } from "styled-components";
import { rgba, position } from "polished";
import { createButtonStyles } from "../../utils/create-button-styles.es.js";
const ButtonClickArea = styled("button")(
  ({ theme }) => ({
    background: "none",
    borderColor: "transparent",
    borderRadius: 2,
    borderStyle: "solid",
    borderWidth: 1,
    boxSizing: "border-box",
    cursor: "pointer",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    fontWeight: theme.fontWeight.normal,
    lineHeight: theme.lineHeight.default,
    margin: 0,
    outline: 0,
    position: "relative",
    textDecoration: "none",
    transition: "all 0.3s cubic-bezier(.645, .045, .355, 1)",
    "&::-moz-focus-inner": {
      border: 0
    }
  }),
  ({ $display }) => $display === "block" ? {
    display: "block",
    width: "100%"
  } : {
    alignItems: "stretch",
    display: "flex"
  },
  ({ $magnitude }) => ({
    medium: {
      padding: "5px 11px",
      minHeight: 32,
      minWidth: 32
    },
    small: {
      padding: "1px 7px",
      minHeight: 24,
      minWidth: 24
    }
  })[$magnitude],
  ({ "aria-expanded": expanded, "aria-pressed": pressed, theme, $variant }) => createButtonStyles({
    disabledBackgroundColor: theme.color.gray3,
    disabledBorderColor: theme.controlBorderColor,
    disabledColor: theme.color.gray6,
    ...{
      action: {
        activeBackgroundColor: theme.color.green8,
        defaultColor: "white",
        defaultBackgroundColor: expanded || pressed ? theme.color.green8 : theme.color.green6,
        focusBoxShadow: `0 0 0 2px ${rgba(theme.color.green6, 0.25)}`,
        disabledFocusBoxShadow: `0 0 0 2px ${rgba("black", 0.05)}`,
        hoverBackgroundColor: theme.color.green7
      },
      danger: {
        activeBackgroundColor: theme.color.red8,
        defaultColor: "white",
        defaultBackgroundColor: expanded || pressed ? theme.color.red8 : theme.color.red6,
        focusBoxShadow: `0 0 0 2px ${rgba(theme.color.red6, 0.25)}`,
        disabledFocusBoxShadow: `0 0 0 2px ${rgba("black", 0.05)}`,
        hoverBackgroundColor: theme.color.red7
      },
      primary: {
        activeBackgroundColor: theme.color.blue8,
        defaultColor: "white",
        defaultBackgroundColor: expanded || pressed ? theme.color.blue8 : theme.color.blue6,
        focusBoxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`,
        disabledFocusBoxShadow: `0 0 0 2px ${rgba("black", 0.05)}`,
        hoverBackgroundColor: theme.color.blue7
      },
      secondary: {
        activeBackgroundColor: rgba("black", 0.1),
        defaultColor: rgba("black", 0.65),
        defaultBackgroundColor: expanded || pressed ? rgba("black", 0.1) : "white",
        defaultBorderColor: theme.controlBorderColor,
        focusBoxShadow: `0 0 0 2px ${rgba("black", 0.05)}`,
        hoverBackgroundColor: "#f2f2f2"
      }
    }[$variant]
  }),
  ({ "aria-busy": busy, "aria-disabled": disabled }) => busy || disabled ? {
    pointerEvents: "none"
  } : void 0
);
const ButtonInner = styled("div")(
  {
    alignItems: "center",
    display: "grid",
    gap: 8,
    gridAutoFlow: "column",
    width: "100%"
  },
  ({ hidden }) => hidden ? { opacity: 0 } : {}
);
const ButtonIcon = styled("span")(
  {
    fontSize: 16,
    lineHeight: "1em",
    width: "1em"
  },
  ({ $magnitude }) => ({
    small: { fontSize: 16 },
    medium: { fontSize: 20 }
  })[$magnitude]
);
const ButtonLoadingOverlay = styled("div")({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  ...position("absolute", 0)
});
const ButtonText = styled("span")({});
export {
  ButtonClickArea,
  ButtonIcon,
  ButtonInner,
  ButtonLoadingOverlay,
  ButtonText
};
